import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBorrowerPrincipalFirstName, useBorrowerPrincipalLastName, useBorrowerPrincipalPhone, useBorrowerPrincipalEmail } from '../../../../../queries/BorrowerFields/PrincipalFields';
import { ShowIf } from '../../../../components/ShowIf';

interface PrincipalContactInfoProps {
    isReview?: boolean;
}

export const PrincipalContactInfo: React.FC<PrincipalContactInfoProps> = ({ isReview = false }) => {
    const [firstName] = useBorrowerPrincipalFirstName();
    const [lastName] = useBorrowerPrincipalLastName();
    const [phone] = useBorrowerPrincipalPhone();
    const [email] = useBorrowerPrincipalEmail();

    const fullContactInfo = () => {
        return (
            <>
                <div style={{ lineHeight: '1.5' }}>
                    {firstName} {lastName}
                    <ShowIf showIf={phone}>
                        <br />
                        {phone}
                    </ShowIf>
                    <ShowIf showIf={email}>
                        <br />
                        {email}
                    </ShowIf>
                </div>
            </>
        );
    };
    return (
        <>
            {isReview && (
                <ApplicationQuestionReviewItem
                    label='My Contact Information'
                    value={fullContactInfo()}
                />
            )}
        </>
    );
};
